/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSeryNoti = /* GraphQL */ `
  query GetSeryNoti($REGDATE: String!) {
    getSeryNoti(REGDATE: $REGDATE) {
      REGDATE
      USEFLAG
      NOTI_TITLE
      NOTI_CONTENT
      WRITER
      UPDATE_DATE
      UPDATE_WRITER
      ADDFILE
      NOTI_TYPE
      NOTI_BUTTON_NAME
      NOTI_BUTTON_LINK
      NOTI_BUTTON_LINK2
    }
  }
`;
export const listSeryNotis = /* GraphQL */ `
  query ListSeryNotis(
    $filter: TableSeryNotiFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSeryNotis(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        REGDATE
        USEFLAG
        NOTI_TITLE
        NOTI_CONTENT
        WRITER
        UPDATE_DATE
        UPDATE_WRITER
        ADDFILE
        NOTI_TYPE
        NOTI_BUTTON_NAME
        NOTI_BUTTON_LINK
        NOTI_BUTTON_LINK2
      }
      nextToken
    }
  }
`;
export const querySeryNotisByUSEFLAGIndex = /* GraphQL */ `
  query QuerySeryNotisByUSEFLAGIndex(
    $USEFLAG: String!
    $first: Int
    $after: String
  ) {
    querySeryNotisByUSEFLAGIndex(
      USEFLAG: $USEFLAG
      first: $first
      after: $after
    ) {
      items {
        REGDATE
        USEFLAG
        NOTI_TITLE
        NOTI_CONTENT
        WRITER
        UPDATE_DATE
        UPDATE_WRITER
        ADDFILE
        NOTI_TYPE
        NOTI_BUTTON_NAME
        NOTI_BUTTON_LINK
        NOTI_BUTTON_LINK2
      }
      nextToken
    }
  }
`;
export const querySeryNotisByUseFlagIndex2 = /* GraphQL */ `
  query QuerySeryNotisByUseFlagIndex2(
    $useFlag: String!
    $first: Int
    $after: String
  ) {
    querySeryNotisByUseFlagIndex2(
      useFlag: $useFlag
      first: $first
      after: $after
    ) {
      items {
        REGDATE
        USEFLAG
        NOTI_TITLE
        NOTI_CONTENT
        WRITER
        UPDATE_DATE
        UPDATE_WRITER
        ADDFILE
        NOTI_TYPE
        NOTI_BUTTON_NAME
        NOTI_BUTTON_LINK
        NOTI_BUTTON_LINK2
      }
      nextToken
    }
  }
`;
export const getSeryRiderInfo = /* GraphQL */ `
  query GetSeryRiderInfo($id: String!, $storeSeq: String!) {
    getSeryRiderInfo(id: $id, storeSeq: $storeSeq) {
      id
      storeSeq
      phone
      pw
      riderName
      useFlag
      gcmKey
    }
  }
`;
export const listSeryRiderInfos = /* GraphQL */ `
  query ListSeryRiderInfos(
    $filter: TableSeryRiderInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSeryRiderInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeSeq
        phone
        pw
        riderName
        useFlag
        gcmKey
      }
      nextToken
    }
  }
`;
export const querySeryRiderInfosByIdIndex = /* GraphQL */ `
  query QuerySeryRiderInfosByIdIndex(
    $id: String!
    $limit: Int
    $nextToken: String
  ) {
    querySeryRiderInfosByIdIndex(
      id: $id
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        storeSeq
        phone
        pw
        riderName
        useFlag
        gcmKey
      }
      nextToken
    }
  }
`;
export const getSeryOrderInfo = /* GraphQL */ `
  query GetSeryOrderInfo($orderSeq: String!) {
    getSeryOrderInfo(orderSeq: $orderSeq) {
      orderSeq
      storeSeq
      userSeq
      deliveryInfo
      orderDate
      paymentType
      deliveryType
      memo
      orderNo
      orderPrice
      deliveryPrice
      orderState
      deliveryName
      deliveryCode
      deliveryNo
      receiveCode
      bookingTime
      detailInfo
      deliveryTime
      doneTime
      riderId
      storeName
      userName
      minPromoCost
      cancelReason
      cancelReasonDetail
      orderReceivedTime
      deliveryCompleteTime
    }
  }
`;
export const listSeryOrderInfos = /* GraphQL */ `
  query ListSeryOrderInfos(
    $startDate: AWSDate
    $endDate: AWSDate
    $type: String
    $nextToken: String
  ) {
    listSeryOrderInfos(
      startDate: $startDate
      endDate: $endDate
      type: $type
      nextToken: $nextToken
    ) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
      nextToken
    }
  }
`;
export const querySeryOrderInfosByUserSeqIndex = /* GraphQL */ `
  query QuerySeryOrderInfosByUserSeqIndex(
    $userSeq: Int!
    $searchType: Int
    $startDate: AWSDate
    $endDate: AWSDate
    $limit: Int
  ) {
    querySeryOrderInfosByUserSeqIndex(
      userSeq: $userSeq
      searchType: $searchType
      startDate: $startDate
      endDate: $endDate
      limit: $limit
    ) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
      nextToken
    }
  }
`;
export const querySeryOrderInfosByUserSeqIndex2 = /* GraphQL */ `
  query QuerySeryOrderInfosByUserSeqIndex2(
    $userSeq: Int!
    $searchType: Int
    $startDate: AWSDateTime
    $endDate: AWSDateTime
    $nextToken: String
    $limit: Int
  ) {
    querySeryOrderInfosByUserSeqIndex2(
      userSeq: $userSeq
      searchType: $searchType
      startDate: $startDate
      endDate: $endDate
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
      nextToken
    }
  }
`;
export const querySeryOrderInfosByUserSeqStoreSeq = /* GraphQL */ `
  query QuerySeryOrderInfosByUserSeqStoreSeq(
    $userSeq: Int!
    $storeSeq: String!
    $searchType: Int
    $startDate: AWSDateTime
    $endDate: AWSDateTime
    $limit: Int
  ) {
    querySeryOrderInfosByUserSeqStoreSeq(
      userSeq: $userSeq
      storeSeq: $storeSeq
      searchType: $searchType
      startDate: $startDate
      endDate: $endDate
      limit: $limit
    ) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
      nextToken
    }
  }
`;
export const querySeryOrderInfosByUserSeqStoreSeq2 = /* GraphQL */ `
  query QuerySeryOrderInfosByUserSeqStoreSeq2(
    $userSeq: Int!
    $storeSeq: String!
    $searchType: Int
    $startDate: AWSDateTime
    $endDate: AWSDateTime
    $limit: Int
    $nextToken: String
  ) {
    querySeryOrderInfosByUserSeqStoreSeq2(
      userSeq: $userSeq
      storeSeq: $storeSeq
      searchType: $searchType
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
      nextToken
    }
  }
`;
export const querySeryOrderInfosByStoreSeqIndex = /* GraphQL */ `
  query QuerySeryOrderInfosByStoreSeqIndex(
    $storeSeq: String!
    $flag: Int
    $orderState: Int
    $startDate: AWSDate
    $endDate: AWSDate
    $nextToken: String
    $limit: Int
  ) {
    querySeryOrderInfosByStoreSeqIndex(
      storeSeq: $storeSeq
      flag: $flag
      orderState: $orderState
      startDate: $startDate
      endDate: $endDate
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
      nextToken
    }
  }
`;
export const querySeryOrderInfosByStoreSeqIndex2 = /* GraphQL */ `
  query QuerySeryOrderInfosByStoreSeqIndex2(
    $storeSeq: String!
    $flag: Int
    $orderState: Int
    $startDate: AWSDate
    $endDate: AWSDate
    $nextToken: String
    $limit: Int
  ) {
    querySeryOrderInfosByStoreSeqIndex2(
      storeSeq: $storeSeq
      flag: $flag
      orderState: $orderState
      startDate: $startDate
      endDate: $endDate
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        orderSeq
        storeSeq
        userSeq
        deliveryInfo
        orderDate
        paymentType
        deliveryType
        memo
        orderNo
        orderPrice
        deliveryPrice
        orderState
        deliveryName
        deliveryCode
        deliveryNo
        receiveCode
        bookingTime
        detailInfo
        deliveryTime
        doneTime
        riderId
        storeName
        userName
        minPromoCost
        cancelReason
        cancelReasonDetail
        orderReceivedTime
        deliveryCompleteTime
      }
      nextToken
    }
  }
`;
export const queryTeryRecipeByUseFlagIndex = /* GraphQL */ `
  query QueryTeryRecipeByUseFlagIndex(
    $regDate: String
    $youtube_id: String
    $contents: String
    $tag: String
    $title: String
    $useFlag: Int!
    $views: Int
  ) {
    queryTeryRecipeByUseFlagIndex(
      regDate: $regDate
      youtube_id: $youtube_id
      contents: $contents
      tag: $tag
      title: $title
      useFlag: $useFlag
      views: $views
    ) {
      items {
        regDate
        youtube_id
        contents
        tag
        title
        useFlag
        views
      }
      nextToken
    }
  }
`;
export const getTeryRecipe = /* GraphQL */ `
  query GetTeryRecipe($youtube_id: String!, $regDate: String!) {
    getTeryRecipe(youtube_id: $youtube_id, regDate: $regDate) {
      regDate
      youtube_id
      contents
      tag
      title
      useFlag
      views
    }
  }
`;
export const listTeryRecipes = /* GraphQL */ `
  query ListTeryRecipes(
    $filter: TableTeryRecipeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeryRecipes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        regDate
        youtube_id
        contents
        tag
        title
        useFlag
        views
      }
      nextToken
    }
  }
`;
export const getTeryRecipeRank = /* GraphQL */ `
  query GetTeryRecipeRank($searchWord: String!) {
    getTeryRecipeRank(searchWord: $searchWord) {
      searchWord
      searchCount
    }
  }
`;
export const listTeryRecipeRanks = /* GraphQL */ `
  query ListTeryRecipeRanks(
    $filter: TableTeryRecipeRankFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeryRecipeRanks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        searchWord
        searchCount
      }
      nextToken
    }
  }
`;
export const getTeryRecipeCategory = /* GraphQL */ `
  query GetTeryRecipeCategory($regDate: String!) {
    getTeryRecipeCategory(regDate: $regDate) {
      regDate
      data
    }
  }
`;
export const listTeryRecipeCategories = /* GraphQL */ `
  query ListTeryRecipeCategories(
    $filter: TableTeryRecipeCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeryRecipeCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        regDate
        data
      }
      nextToken
    }
  }
`;
export const getStoreProductComment = /* GraphQL */ `
  query GetStoreProductComment($storeProductSeq: String!) {
    getStoreProductComment(storeProductSeq: $storeProductSeq) {
      storeProductSeq
      regDate
      userSeq
      userImageUrl
      userName
      storeSeq
      depth
      memo
      commentType
      commentHead
      isRead
    }
  }
`;
export const queryStoreProductComment = /* GraphQL */ `
  query QueryStoreProductComment(
    $storeSeq: String!
    $commentHead: String
    $commentType: Int
    $storeProductSeq: String
    $regDate: String
    $userSeq: Int
    $limit: Int
    $nextToken: String
  ) {
    queryStoreProductComment(
      storeSeq: $storeSeq
      commentHead: $commentHead
      commentType: $commentType
      storeProductSeq: $storeProductSeq
      regDate: $regDate
      userSeq: $userSeq
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        storeProductSeq
        regDate
        userSeq
        userImageUrl
        userName
        storeSeq
        depth
        memo
        commentType
        commentHead
        isRead
      }
      nextToken
      scannedCount
    }
  }
`;
export const listStoreProductComments = /* GraphQL */ `
  query ListStoreProductComments(
    $filter: TableStoreProductCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreProductComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        storeProductSeq
        regDate
        userSeq
        userImageUrl
        userName
        storeSeq
        depth
        memo
        commentType
        commentHead
        isRead
      }
      nextToken
      scannedCount
    }
  }
`;
export const getStoreQnaInfoTable = /* GraphQL */ `
  query GetStoreQnaInfoTable($storeSeq: String!, $sK: String!) {
    getStoreQnaInfoTable(storeSeq: $storeSeq, sK: $sK) {
      sK
      storeSeq
      datetime
      name
      contents
      userSeq
      userPhone
      type
      isRead
      roomType
      userProfile
      numberParticipants
      userIndex
    }
  }
`;
export const listStoreQnaInfoTables = /* GraphQL */ `
  query ListStoreQnaInfoTables(
    $filter: TableStoreQnaInfoTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreQnaInfoTables(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        sK
        storeSeq
        datetime
        name
        contents
        userSeq
        userPhone
        type
        isRead
        roomType
        userProfile
        numberParticipants
        userIndex
      }
      nextToken
    }
  }
`;
export const queryStoreQnaInfoTable = /* GraphQL */ `
  query QueryStoreQnaInfoTable(
    $storeSeq: String
    $sK: String!
    $datetime: String
    $limit: Int
    $nextToken: String
  ) {
    queryStoreQnaInfoTable(
      storeSeq: $storeSeq
      sK: $sK
      datetime: $datetime
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        sK
        storeSeq
        datetime
        name
        contents
        userSeq
        userPhone
        type
        isRead
        roomType
        userProfile
        numberParticipants
        userIndex
      }
      nextToken
    }
  }
`;
export const getUpdateCheck = /* GraphQL */ `
  query GetUpdateCheck($type: String!, $version: String!) {
    getUpdateCheck(type: $type, version: $version) {
      type
      version
      coercionFlag
      regDate
      updateUrl
    }
  }
`;
export const queryUpdateCheckVersion = /* GraphQL */ `
  query QueryUpdateCheckVersion($type: String!) {
    queryUpdateCheckVersion(type: $type) {
      items {
        type
        version
        coercionFlag
        regDate
        updateUrl
      }
      nextToken
    }
  }
`;
export const listUpdateChecks = /* GraphQL */ `
  query ListUpdateChecks(
    $filter: TableUpdateCheckFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUpdateChecks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        type
        version
        coercionFlag
        regDate
        updateUrl
      }
      nextToken
    }
  }
`;
export const getTeryMarketNoti = /* GraphQL */ `
  query GetTeryMarketNoti($orderSeq: Int!) {
    getTeryMarketNoti(orderSeq: $orderSeq) {
      orderSeq
      storeSeq
      status
    }
  }
`;
export const listTeryMarketNotis = /* GraphQL */ `
  query ListTeryMarketNotis(
    $filter: TableTeryMarketNotiFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeryMarketNotis(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        orderSeq
        storeSeq
        status
      }
      nextToken
    }
  }
`;
export const queryTeryMarketNotisByStoreSeqIndex = /* GraphQL */ `
  query QueryTeryMarketNotisByStoreSeqIndex(
    $storeSeq: String!
    $first: Int
    $after: String
  ) {
    queryTeryMarketNotisByStoreSeqIndex(
      storeSeq: $storeSeq
      first: $first
      after: $after
    ) {
      items {
        orderSeq
        storeSeq
        status
      }
      nextToken
    }
  }
`;
export const getBooking = /* GraphQL */ `
  query GetBooking($booking_idx: String!) {
    getBooking(booking_idx: $booking_idx) {
      booking_idx
      product_fk
      STAFF_FK
      NAME
      STORE_SEQ
      PHONE_NUMBER
      BOOKING_DATE
      START_TIME
      END_TIME
      MEMO
      ETC
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js